import SectionHeading from "./SectionHeading";
import { topics } from "@/mocks/people";

export default function Topics() {
  return (
    <section id="topics" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="SPECIAL · 热门专题"
        title="把零散线索串成完整专题"
        desc="专题合集会把相关的爆料、回应和时间线整理在一起，比碎片帖子更容易看明白一件事的全貌。"
      />

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-5">
        {topics.map((topic) => (
          <article
            key={topic.id}
            className="group relative rounded-lg overflow-hidden border border-background-200"
          >
            <div className="relative w-full h-48 lg:h-56 overflow-hidden">
              <img
                src={topic.image}
                alt={topic.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="font-label text-xs text-accent-300 bg-accent-500/25 border border-accent-400/40 px-2 py-0.5 rounded-md">
                  {topic.tag}
                </span>
                <span className="text-xs text-background-100/85">收录 {topic.count} 条</span>
              </div>
              <h3 className="text-lg font-bold text-background-50">{topic.title}</h3>
              <p className="mt-2 text-xs md:text-sm leading-relaxed text-background-100/85 line-clamp-3">
                {topic.desc}
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}